module.exports = __webpack_public_path__ + "static/img/zhizhen1.b51746a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market105/zhizhen1.png
// module id = 5CV+
// module chunks = 1